module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "organizationlist"
  }, [_c('div', {
    staticClass: "container_wrap"
  }, [_c('el-breadcrumb', {
    staticClass: "elbreadcrumb",
    attrs: {
      "separator-class": "el-icon-arrow-right"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/indexpc'
      }
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("机构列表")])], 1), _vm._v(" "), _c('div', {
    staticClass: "star_list"
  }, [_c('div', {
    staticClass: "apply_now"
  }, [_c('div', {
    staticClass: "apply_now_pic"
  }), _vm._v(" "), _c('div', {
    staticClass: "apply_now_btn",
    on: {
      "click": function($event) {
        return _vm.applyJustNowFun()
      }
    }
  }, [_vm._v("立即申请")])]), _vm._v(" "), _vm._l((_vm.ItemData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "star_list_item",
      on: {
        "click": function($event) {
          return _vm.starItemClick(item)
        }
      }
    }, [_c('div', {
      staticClass: "star_list_item_pic"
    }, [(item.certificatepic && item.certificatepic.length) ? _c('img', {
      attrs: {
        "src": item.certificatepic[0].url,
        "alt": ""
      }
    }) : _c('img', {
      attrs: {
        "src": "#",
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "star_list_item_title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "star_list_item_decs"
    }, [_vm._v(_vm._s(item.content))])])
  })], 2)], 1), _vm._v(" "), _c('DeBounce', {
    attrs: {
      "fetch-fun": _vm.getNewsItemlist,
      "pagefetchflag": _vm.pagefetchflag
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78d2eba6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/OrganizationList.vue
// module id = 1288
// module chunks = 0